document.addEventListener('DOMContentLoaded', () => {
    // slick default setting
    let defaulsettings = {
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: '.swiper-prev',
            prevEl: '.swiper-next'
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        }
    };

    // start slider default
    let allSwipper =[];

    document.querySelectorAll('.swiper-slider').forEach((element,i) => {

        let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaulsettings;
        element.setAttribute(`data-swiper-${i}`,"");
        let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);
        allSwipper[i] = swiper;

    });

    let topContentSlider = new Swiper('.top-content__slider',{
        loop: true,
        speed: 800,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        autoplay: {
            delay: 4000,
            disableOnInteraction: false
        }
    });

    let testimonialSlider = new Swiper('.testimonials_slider',{
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: '.testimonials-next',
            prevEl: '.testimonials-prev'
        },
    });
});